import { SvgIcon } from '@mui/material';
import { IconProps } from './types/iconTypes';
export default function CloseIcon({
  color = '#202225',
  width = '24',
  height = '24',
  className
}: IconProps) {
  return <SvgIcon className={className} width={`${width}px`} height={`${height}px`} viewBox={`0 0 ${width} ${height}`} data-sentry-element="SvgIcon" data-sentry-component="CloseIcon" data-sentry-source-file="CloseIcon.tsx">
			<path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill={color} data-sentry-element="path" data-sentry-source-file="CloseIcon.tsx" />
		</SvgIcon>;
}